import { AbstractBprocRequest } from "./AbstractBprocRequest";
import { PersonGroupExt } from "./base$PersonGroupExt";
import { PositionGroupExt } from "./base$PositionGroupExt";
import { GradeGroup } from "./tsadv$GradeGroup";
import { OrganizationGroupExt } from "./base$OrganizationGroupExt";
import { JobGroup } from "./tsadv$JobGroup";
import { DicCurrency } from "./base$DicCurrency";
import { DicSalaryChangeReason } from "./tsadv$DicSalaryChangeReason";
import { DicWCCFType } from "./tsadv_DicWCCFType";
import { FileDescriptor } from "./sys$FileDescriptor";
export class AssignmentSalaryRequest extends AbstractBprocRequest {
  static NAME = "tsadv$AssignmentSalaryRequest";
  personGroup?: PersonGroupExt | null;
  dateFrom?: any | null;
  dateTo?: any | null;
  actualPositionGroup?: PositionGroupExt | null;
  planDate?: any | null;
  actualDate?: any | null;
  positionGroup?: PositionGroupExt | null;
  gradeGroup?: GradeGroup | null;
  organizationGroup?: OrganizationGroupExt | null;
  jobGroup?: JobGroup | null;
  type?: any | null;
  amount?: any | null;
  changePercent?: any | null;
  netGross?: any | null;
  currency?: DicCurrency | null;
  reason?: DicSalaryChangeReason | null;
  salaryComment?: string | null;
  substitutedEmployee?: PersonGroupExt | null;
  wccfType?: DicWCCFType | null;
  files?: FileDescriptor[] | null;
}
export type AssignmentSalaryRequestViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "assignmentSalaryRequest-browse"
  | "assignmentSalaryRequest-for-check"
  | "assignmentSalaryRequest-for-integration"
  | "assignmentSalaryRequest-for-integration"
  | "assignmentSalaryRequest-view"
  | "portal-assignmentSalaryRequest-edit";
export type AssignmentSalaryRequestView<
  V extends AssignmentSalaryRequestViewName
> = V extends "_base"
  ? Pick<
      AssignmentSalaryRequest,
      | "id"
      | "requestNumber"
      | "personGroup"
      | "dateFrom"
      | "dateTo"
      | "planDate"
      | "actualDate"
      | "type"
      | "amount"
      | "changePercent"
      | "netGross"
      | "salaryComment"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestDate"
      | "comment"
    >
  : V extends "_local"
  ? Pick<
      AssignmentSalaryRequest,
      | "id"
      | "dateFrom"
      | "dateTo"
      | "planDate"
      | "actualDate"
      | "type"
      | "amount"
      | "changePercent"
      | "netGross"
      | "salaryComment"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestNumber"
      | "requestDate"
      | "comment"
    >
  : V extends "_minimal"
  ? Pick<AssignmentSalaryRequest, "id" | "requestNumber" | "personGroup">
  : V extends "assignmentSalaryRequest-browse"
  ? Pick<
      AssignmentSalaryRequest,
      | "id"
      | "dateFrom"
      | "dateTo"
      | "planDate"
      | "actualDate"
      | "type"
      | "amount"
      | "changePercent"
      | "netGross"
      | "salaryComment"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestNumber"
      | "requestDate"
      | "comment"
      | "personGroup"
      | "actualPositionGroup"
      | "positionGroup"
      | "gradeGroup"
      | "organizationGroup"
      | "jobGroup"
      | "currency"
      | "reason"
      | "wccfType"
      | "status"
    >
  : V extends "assignmentSalaryRequest-for-check"
  ? Pick<
      AssignmentSalaryRequest,
      | "id"
      | "requestNumber"
      | "personGroup"
      | "amount"
      | "changePercent"
      | "currency"
      | "requestDate"
      | "gradeGroup"
    >
  : V extends "assignmentSalaryRequest-for-integration"
  ? Pick<
      AssignmentSalaryRequest,
      | "id"
      | "dateFrom"
      | "dateTo"
      | "planDate"
      | "actualDate"
      | "type"
      | "amount"
      | "changePercent"
      | "netGross"
      | "salaryComment"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestNumber"
      | "requestDate"
      | "comment"
      | "personGroup"
      | "actualPositionGroup"
      | "positionGroup"
      | "gradeGroup"
      | "organizationGroup"
      | "wccfType"
      | "status"
    >
  : V extends "assignmentSalaryRequest-for-integration"
  ? Pick<
      AssignmentSalaryRequest,
      | "id"
      | "dateFrom"
      | "dateTo"
      | "planDate"
      | "actualDate"
      | "type"
      | "amount"
      | "changePercent"
      | "netGross"
      | "salaryComment"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestNumber"
      | "requestDate"
      | "comment"
      | "personGroup"
      | "actualPositionGroup"
      | "positionGroup"
      | "gradeGroup"
      | "organizationGroup"
      | "wccfType"
      | "status"
      | "jobGroup"
    >
  : V extends "assignmentSalaryRequest-view"
  ? Pick<
      AssignmentSalaryRequest,
      | "id"
      | "version"
      | "createTs"
      | "createdBy"
      | "updateTs"
      | "updatedBy"
      | "deleteTs"
      | "deletedBy"
      | "dateFrom"
      | "dateTo"
      | "planDate"
      | "actualDate"
      | "type"
      | "amount"
      | "changePercent"
      | "netGross"
      | "salaryComment"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestNumber"
      | "requestDate"
      | "comment"
      | "personGroup"
      | "positionGroup"
      | "gradeGroup"
      | "organizationGroup"
      | "jobGroup"
      | "currency"
      | "reason"
      | "status"
    >
  : V extends "portal-assignmentSalaryRequest-edit"
  ? Pick<
      AssignmentSalaryRequest,
      | "id"
      | "dateFrom"
      | "dateTo"
      | "planDate"
      | "actualDate"
      | "type"
      | "amount"
      | "changePercent"
      | "netGross"
      | "salaryComment"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestNumber"
      | "requestDate"
      | "comment"
      | "personGroup"
      | "positionGroup"
      | "gradeGroup"
      | "organizationGroup"
      | "jobGroup"
      | "wccfType"
      | "status"
      | "files"
      | "currency"
    >
  : never;
